module.exports = __webpack_public_path__ + "static/media/positive-image4.80f71ae0.jpg";